import React, { useState } from "react";

const HoverHelpBubble = ({ children, description }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="relative group inline-block"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {/* Render the child element */}
      {children}

      {/* The help bubble */}
      {isHovered && (
        <div className="border border-pink-300/30 absolute bg-gray-900/95 text-white text-sm p-2 rounded-lg shadow-md w-60 bottom-full left-1/2 transform -translate-x-1/2 mb-2 z-10">
          {description}
        </div>
      )}
    </div>
  );
};

export default HoverHelpBubble;
